import * as yup from 'yup';
import { WEBHOOK_EVENTS, WEBHOOK_HTTP_METHODS } from 'types';

const ALLOWED_EVENTS = WEBHOOK_EVENTS.map(e => e.value);

const webhookSchema = yup.object().shape({
  name: yup
    .string()
    .trim()
    .max(60, 'Name must be at most 60 characters')
    .required('Name is required!'),
  url: yup
    .string()
    .trim()
    .max(2048, 'URL must be at most 2048 characters')
    .matches(
      /^https?:\/\/\S+$/i,
      'Must be a valid URL starting with http:// or https://'
    )
    .required('URL is required!'),
  method: yup
    .string()
    .oneOf(WEBHOOK_HTTP_METHODS, 'Method must be one of POST, PUT, PATCH')
    .required('Method is required!'),
  events: yup
    .array()
    .of(yup.string().oneOf(ALLOWED_EVENTS, 'Unknown event type'))
    .min(1, 'At least one event must be selected')
    .required('At least one event must be selected'),
  isActive: yup.boolean(),
});

export default webhookSchema;
